"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
var _clickoutside = _interopRequireDefault(require("element-ui/src/utils/clickoutside"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  directives: {
    Clickoutside: _clickoutside.default
  },
  props: {
    defaultColumn: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      checkedSelectProps: [],
      open: false
    };
  },
  created: function created() {
    var _this = this;
    this.checkedSelectProps = [];
    this.defaultColumn.map(function (item) {
      // 如果为true 那么就push
      item.isShow && _this.checkedSelectProps.push(item.name);
    });
  },
  methods: {
    openHandle: function openHandle() {
      this.open = !this.open;
    },
    clickoutsideHandle: function clickoutsideHandle() {
      this.open = false;
    },
    selectUIChange: function selectUIChange(value) {
      // 提交的改变数据
      this.$emit("change", value);
    }
  }
};